<template>
  <div
    id="flashcard-view-container-v2"
    ref="flashcard-view-container"
    class="flashcard-view-container"
  >
    <breadcrumbs
      :breadcrumbs="breadcrumbs"
      version="v2"
    ></breadcrumbs>
    <template
      v-if="answered"
    >
      <answered-flashcard
        :answer-ids="answerIds"
        :category="currentFlashcardCategory"
        :correct="correct"
        :flashcard="currentFlashcard"
        :raw-answer-data="rawAnswerData"
      ></answered-flashcard>
      <answered-footer
        :category="currentFlashcardCategory"
        :flashcard="currentFlashcard"
        :show-flashcard-statuses="true"
        @tag="tryTagFlashcard"
      ></answered-footer>
    </template>

    <template
      v-else
    >
      <unanswered-header
        :category="currentFlashcardCategory"
        :flashcard="currentFlashcard"
      ></unanswered-header>
      <resource-id-button
        :resource="currentFlashcard"
      ></resource-id-button>
      <unanswered-flashcard
        :answer-ids="answerIds"
        :category="currentFlashcardCategory"
        :flashcard="currentFlashcard"
        :raw-answer-data="rawAnswerData"
        :sharing-enabled="sharingEnabled"
        :terminology="isTerminology"
        @set-answer-ids="setAnswerIds"
        @set-raw-answer-data="setRawAnswerData"
        @try-answer-flashcard="tryAnswerFlashcard"
      ></unanswered-flashcard>
      <unanswered-footer
        :can-submit-answer="canSubmitAnswer"
        :category="currentFlashcardCategory"
        :flashcard="currentFlashcard"
        @answer="answerFlashcard"
        @next-flashcard="goToNextFlashcard"
        @previous-flashcard="goToPreviousFlashcard"
      ></unanswered-footer>
    </template>
  </div>
</template>

<script>
import AnsweredFlashcard from '@/components/flashcards-v2/AnsweredFlashcard';
import AnsweredFooter from '@components/flashcards-v2/AnsweredFooter';
import Breadcrumbs from '@components/singletons/breadcrumbs';
import ResourceIdButton from '@components/singletons/ResourceIdButton';
import UnansweredFlashcard from '@components/flashcards-v2/UnansweredFlashcard';
import UnansweredFooter from '@components/flashcards-v2/UnansweredFooter';
import UnansweredHeader from '@/components/flashcards-v2/UnansweredHeader.vue';
import FlashcardViewMixin from '@/mixins/flashcardViews';
import GlobalMixin from '@/mixins/global';
import RateLimitMixin from '@/mixins/rate-limit';
import QuestionOfTheDayMixin from '@/mixins/qotd';

export default {
  components: {
    AnsweredFlashcard,
    AnsweredFooter,
    Breadcrumbs,
    ResourceIdButton,
    UnansweredFlashcard,
    UnansweredFooter,
    UnansweredHeader,
  },
  mixins: [FlashcardViewMixin, GlobalMixin, RateLimitMixin, QuestionOfTheDayMixin],
  data() {
    return {
      nextFlashcardRoute: { name: 'learningPath#setup' },
    };
  },
  computed: {
    breadcrumbs() {
      if (!this.currentFlashcardCategory) return [];
      let categories = this.currentFlashcardCategory.path.split('.').map(id => this.$store.getters['categories/categories'][id]);
      let crumbs = categories.map(c => {
        return { name: c.name, route: {name: 'categories#index', params: { categoryId: c.id}, query: this.currentQuery}};
      });
      return crumbs;
    },
    currentFlashcard() {
      return this.$store.getters['flashcards/flashcards'][this.flashcardId] || {};
    },
    currentFlashcardCategory() {
      return this.$store.getters['categories/categories'][this.questionOfTheDay?.categoryId];
    },
    date() {
      const date = this.$route.params.date;
      if (!this.validateDateParam(date)) {
        return '';
      }
      return this.$route.params.date;
    },
    questionOfTheDay() {
      return this.$store.getters['questionsOfTheDay/getByDate'](this.date);
    },
    flashcardId() {
      return this.questionOfTheDay?.v3FlashcardId;
    },
    sharingEnabled() {
      const enabled = !!(this.$store.getters['productVars/get']['flashcardShareMessage']);
      return enabled && !this.onTour;
    },
    canSubmitAnswer() {
      return this.hasBeenAnswered;
    },
  },
  mounted() {
    this.$store.dispatch('flashcardStates/fetchStates', ['bookmarks', 'flashcards', 'stats']);
    if (!this.date) {
      this.$router.push({ name: 'home' });
    } else if (!this.questionOfTheDay) {
      this.fetchQuestionOfTheDay(this.date);
    } else if (!this.currentFlashcard.id && this.flashcardId) {
      this.$store.dispatch('flashcards/fetchFlashcards', {
        ids: [this.flashcardId], rateLimited: this.rateLimitingEnabled,
      });
    }
  },
  methods: {
    async fetchQuestionOfTheDay(date) {
      const { question } = await this.$store.dispatch('questionsOfTheDay/fetchQuestionOfTheDayByDate', date);
      if (question) {
        this.$store.commit('flashcards/setFlashcards', { records: [question] });
      }
    },
    redirectToTodaysQuestion() {
      this.$router.push({ name: 'qotd-v2#index', params: { date: '' } });
    },
    tryAnswerFlashcard() {
      if (this.canSubmitAnswer) {
        this.answerFlashcard();
      }
    },
    tryTagFlashcard(statusId) {
      this.tagFlashcard(statusId);
    },
    validateDateParam(date) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      return dateRegex.test(date);
    },
  },
};
</script>

<style lang='scss' scoped>
  #flashcard-view-container-v2 {
    @include flashcard-view-container-v2;
  }
</style>
